import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../assets/css/navbar.css";
import Logo from "../../assets/images/Home/logo.png";

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header className="navbar">

            {/* Logo */}
            <div className="logo">
                <img src={Logo} alt="StoryLine Studios Logo" />

                <div className="logo-text">
                    <h2>StoryLine Studios</h2>
                    <span>Photography & Films</span>
                </div>
            </div>

            {/* Hamburger */}
            <div
                className={`menu-toggle ${menuOpen ? "active" : ""}`}
                onClick={() => setMenuOpen(!menuOpen)}
            >
                <span></span>
                <span></span>
                <span></span>
            </div>

            {/* Navigation */}
            <nav className={menuOpen ? "nav-active" : ""}>
                <ul>

                    <li>
                        <Link to="/home" onClick={() => setMenuOpen(false)}>Home</Link>
                    </li>

                    <li>
                        <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
                    </li>

                    <li>
                        <Link to="/gallery" onClick={() => setMenuOpen(false)}>Gallery</Link>
                    </li>

                    <li>
                        <Link to="/packages" onClick={() => setMenuOpen(false)}>Packages</Link>
                    </li>

                    <li>
                        <Link to="/feedback" onClick={() => setMenuOpen(false)}>Feedback</Link>
                    </li>

                    <li>
                        <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
                    </li>

                </ul>

                <Link
                    to="/contact"
                    className="book-btn mobile-btn"
                    onClick={() => setMenuOpen(false)}
                >
                    Book Now
                </Link>
            </nav>

            <Link
                to="/contact"
                className="book-btn desktop-btn"
            >
                Book Now
            </Link>

        </header>
    );
}

export default Navbar;